export class FetchEvents {
  static readonly type = '[Event] Fetch all';

  constructor(public force: boolean = false) {}
}

export class FetchEventUserRegistrations {
  static readonly type = '[Event] Fetch event user registrations';

  constructor(public force: boolean = false) {}
}
